/* ============================================================
 * LX Sticky Footer — Cart Count Sync (R49)
 * 作成: 2026-06-15 / SKILL v5.46
 * ----------------------------------------------------------------
 * 7 系統 hook で cart/add を捕捉し、sticky-footer の cart badge と
 * 既存ヘッダーの [data-header-cart-count] を同時更新。
 *   1) cart:added / cart:updated / cart-drawer:opened 標準イベント
 *   2) form[action*="/cart/add"] submit
 *   3) fetch monkey-patch（/cart/add, /cart/update, /cart/change）
 *   4) cross-tab storage event
 *   5) visibilitychange（タブ復帰時）
 *   6) 5min interval fallback
 *   7) DOMContentLoaded 初回フェッチ
 * ============================================================ */
(function () {
  'use strict';

  var FETCH_DELAY_AFTER_FORM = 800;   // ms
  var FETCH_DELAY_AFTER_AJAX = 300;   // ms
  var POLL_INTERVAL = 5 * 60 * 1000;  // 5 min
  var STORAGE_KEY = 'lx-cart-touch';

  function setCount(n) {
    var num = (typeof n === 'number' && isFinite(n)) ? n : 0;

    // 1) sticky-footer の bubble
    var el = document.getElementById('lx-cart-count');
    if (el) {
      el.textContent = num;
      el.dataset.cartCount = num;
    }

    // 2) 既存ヘッダーの全ての data-header-cart-count
    var heads = document.querySelectorAll('[data-header-cart-count]');
    for (var i = 0; i < heads.length; i++) {
      heads[i].textContent = num;
    }
  }

  var _inFlight = false;
  function refreshCartCount() {
    if (_inFlight) return;
    _inFlight = true;
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        setCount(data && data.item_count);
        notifyCartTouched();
      })
      .catch(function () { /* network error — keep current */ })
      .then(function () { _inFlight = false; });
  }

  function notifyCartTouched() {
    try { localStorage.setItem(STORAGE_KEY, String(Date.now())); } catch (e) {}
  }

  // ============================================================
  // 1) 標準 cart イベント
  // ============================================================
  document.addEventListener('cart:added', refreshCartCount);
  document.addEventListener('cart:updated', refreshCartCount);
  document.addEventListener('cart-drawer:opened', refreshCartCount);
  document.addEventListener('cart:refresh', refreshCartCount);

  // ============================================================
  // 2) form submit hook
  // ============================================================
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action) return;
    var a = form.action;
    if (a.indexOf('/cart/add') !== -1 ||
        a.indexOf('/cart/update') !== -1 ||
        a.indexOf('/cart/change') !== -1) {
      setTimeout(refreshCartCount, FETCH_DELAY_AFTER_FORM);
    }
  }, true);

  // ============================================================
  // 3) fetch monkey-patch
  // ============================================================
  if (typeof window.fetch === 'function') {
    var originalFetch = window.fetch.bind(window);
    window.fetch = function () {
      var args = arguments;
      var url = '';
      try {
        url = (typeof args[0] === 'string') ? args[0]
            : (args[0] && args[0].url) ? args[0].url : '';
      } catch (e) {}
      var isCart = url.indexOf('/cart/add') !== -1
                || url.indexOf('/cart/update') !== -1
                || url.indexOf('/cart/change') !== -1;
      var p = originalFetch.apply(this, args);
      if (isCart) {
        p.then(function () {
          setTimeout(refreshCartCount, FETCH_DELAY_AFTER_AJAX);
        }).catch(function () {});
      }
      return p;
    };
  }

  // ============================================================
  // 3b) XMLHttpRequest hook (legacy AJAX cart libraries)
  // ============================================================
  if (window.XMLHttpRequest && XMLHttpRequest.prototype.open) {
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        if (url && (url.indexOf('/cart/add') !== -1 ||
                    url.indexOf('/cart/update') !== -1 ||
                    url.indexOf('/cart/change') !== -1)) {
          this.addEventListener('load', function () {
            setTimeout(refreshCartCount, FETCH_DELAY_AFTER_AJAX);
          });
        }
      } catch (e) {}
      return origOpen.apply(this, arguments);
    };
  }

  // ============================================================
  // 4) cross-tab storage event
  // ============================================================
  window.addEventListener('storage', function (e) {
    if (e.key === STORAGE_KEY) refreshCartCount();
  });

  // ============================================================
  // 5) visibilitychange
  // ============================================================
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') refreshCartCount();
  });

  // ============================================================
  // 6) 5min interval fallback
  // ============================================================
  setInterval(refreshCartCount, POLL_INTERVAL);

  // ============================================================
  // 7) 初回 load — server-rendered の cart.item_count を尊重しつつ
  //     軽く 1 回だけ突き合わせ
  // ============================================================
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshCartCount);
  } else {
    refreshCartCount();
  }

  // 公開 API
  window.LXStickyFooter = {
    refresh: refreshCartCount,
    setCount: setCount
  };
})();
